var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"acesso-user"},[_c('v-card',{staticClass:"py-4 px-2 auth-content",attrs:{"tile":"","elevation":"6"}},[_c('PageTitle',{attrs:{"main":"Administração","icon":"mdi-pencil-box-outline","sub":"Views do sistema","home":"/administracao"}}),_c('Form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }